"use client"

import {useSearchParams} from "next/navigation";

export function useIsEmbedded() {
    const params = useSearchParams();
    return Boolean(params?.get("frame_id"));
}
